const getWrongGuessCount = (guesses:Array<string>, word:string) => {
  const uniqueCharsInWord = new Set(word.split(''))

  return guesses
    .reduce((acc, current) => !uniqueCharsInWord.has(current) ? acc + 1 : acc, 0)
}

export default getWrongGuessCount
